import React, {Suspense} from "react";
import Rectangle from '@/Icons/shapes/rectangle-round-corners.svg';
import RectangleRoundMg from '@/Icons/shapes/rectangle-round-corners-mg.svg';
import RectangleSquareMg from '@/Icons/shapes/rectangle-square-corners-mg.svg';
import Square from '@/Icons/shapes/square-round-corners.svg';
import SquareRoundMg from '@/Icons/shapes/square-round-corners-mg.svg';
import SquareSquareMg from '@/Icons/shapes/square-square-corners-mg.svg';
import Arched from '@/Icons/shapes/arched.svg';
import Band from '@/Icons/shapes/band.svg';
import Barrel from '@/Icons/shapes/barrel.svg';
import CD from '@/Icons/shapes/cd.svg';
import Circle from '@/Icons/shapes/circle.svg';
import Heart from '@/Icons/shapes/heart.svg';
import Hexagon from '@/Icons/shapes/hexagon.svg';
import LidSeal from '@/Icons/shapes/lid-seal.svg';
import LidSealRectangle from '@/Icons/shapes/lid-seal-rectangle.svg';
import LipBalmAU from "@/Icons/shapes/lip-balm-au.svg";
import LipBalm from "@/Icons/shapes/lip-balm.svg";
import Oval from '@/Icons/shapes/oval.svg';
import Plaque from '@/Icons/shapes/plaque.svg';
import Scallop from '@/Icons/shapes/scallop.svg';
import StraightOval from '@/Icons/shapes/straight-oval.svg';
import Triangle from '@/Icons/shapes/triangle.svg';
import LoopTag from '@/Icons/shapes/loop_tag.svg';
import PlantSmallTag from '@/Icons/shapes/plant_small_tag.svg';
import PlantLargeTag from '@/Icons/shapes/plant_large_tag.svg';
import RectangleLuggageTag from '@/Icons/shapes/rectangle_luggage_tag.svg';
import RectangleRoundTag from '@/Icons/shapes/rectangle_round_tag.svg';
import RectangleTag from '@/Icons/shapes/rectangle_tag.svg';
import RoundTag from '@/Icons/shapes/round_tag.svg';
import SquareRoundTag from '@/Icons/shapes/square_round_tag.svg';
import SquareTag from '@/Icons/shapes/square_tag.svg';
import DustCoverStandard from '@/Icons/shapes/dust_cover_standardwick.svg';
import DustCoverWood from '@/Icons/shapes/dust_cover_woodwick.svg';
import Binder2Rings from '@/Icons/shapes/binder_2rings.svg';
import Binder4Rings from '@/Icons/shapes/binder_4rings.svg';
import CustomShape from '@/Icons/shapes/custom.svg';
import CustomShapeFr from '@/Icons/shapes/custom_FR.svg';
import CustomShapeEs from '@/Icons/shapes/custom_ES.svg';
import CustomShapeDe from '@/Icons/shapes/custom_DE.svg';
import CigarBand from '@/Icons/shapes/cigar-band.svg';
import CigarBottleNeck from '@/Icons/shapes/cigar-bottle-neck.svg';
import DoubleRoundLid from '@/Icons/shapes/double-round-lid.svg';
import HexagonLid from '@/Icons/shapes/hexagon-lid.svg';
import TailLid from '@/Icons/shapes/tail-lid.svg';
import Star from '@/Icons/shapes/star.svg';
import RectangleRoundLid from '@/Icons/shapes/rectangle-round-lid.svg';
import RectangleRoundCornerHoleTag from '@/Icons/shapes/rectangle-round-corner-hole-tag.svg';
import RectangleCornerHoleTag from '@/Icons/shapes/rectangle-corner-hole-tag.svg';
import ScallopTag from '@/Icons/shapes/scallop-tag.svg';
import BottleNeckTag from '@/Icons/shapes/bottle-neck-tag.svg';
import HeartTag from '@/Icons/shapes/heart-tag.svg';
import ArchTag from '@/Icons/shapes/arched-tag.svg';

//Lazyload SVGs which are not used by every market
const CustomShapeDK = React.lazy(() => import('@/Icons/shapes/custom_DK.svg'));
const CustomShapeNo = React.lazy(() => import('@/Icons/shapes/custom_NO.svg'));
const CustomShapeIt = React.lazy(() => import('@/Icons/shapes/custom_IT.svg'));
const CustomShapePl = React.lazy(() => import('@/Icons/shapes/custom_PL.svg'));
const CustomShapePt = React.lazy(() => import('@/Icons/shapes/custom_PT.svg'));
const CustomShapeSe = React.lazy(() => import('@/Icons/shapes/custom_SE.svg'));

const ShapeIcon = ({id, attributes = {}}) => {
  let Icon;
  switch (id) {
    case 'sha_arch_tag':
      Icon = ArchTag;
      break;
    case 'sha_heart_tag':
      Icon = HeartTag;
      break;
    case 'sha_bottle_neck_tag':
      Icon = BottleNeckTag;
      break;
    case 'sha_scallop_tag':
      Icon = ScallopTag;
      break;
    //This shape doesn't exist, just a preparation if this gets renamed
    case 'sha_rectangle_round_corner_hole_tag':
    case 'sha_corner_hole_round_tag':
      Icon = RectangleRoundCornerHoleTag;
      break;
    //This shape doesn't exist, just a preparation if this gets renamed
    case 'sha_rectangle_corner_hole_tag':
    case 'sha_corner_hole_square_tag':
      Icon = RectangleCornerHoleTag;
      break;
    case 'sha_rectangle_round_lid':
      Icon = RectangleRoundLid;
      break;
    case 'sha_star':
      Icon = Star;
      break;
    case 'sha_tail_lid':
      Icon = TailLid;
      break;
    case 'sha_hexagon_lid':
      Icon = HexagonLid;
      break;
    case 'sha_double_round_lid':
      Icon = DoubleRoundLid;
      break;
    case 'sha_cigar_shape_neck':
      Icon = CigarBottleNeck;
      break;
    case 'sha_cigar_band':
      Icon = CigarBand;
      break;
    case 'sha_arched':
    case 'sha_wpau_arched':
    case 'sha_pamau_arched':
      Icon = Arched;
      break;
    case 'sha_rectangle':
    case 'sha_rectangle_round':
    case 'sha_wpau_rectangle':
    case 'sha_pamau_rectangle':
      Icon = Rectangle;
      break;
    case 'sha_rectangle_mg':
      Icon = RectangleSquareMg;
      break;
    case 'sha_rectangle_round_mg':
      Icon = RectangleRoundMg;
      break;
    case 'sha_square':
    case 'sha_square_round':
    case 'sha_wpau_square':
    case 'sha_pamau_square':
      Icon = Square;
      break;
    case 'sha_square_mg':
      Icon = SquareSquareMg;
      break;
    case 'sha_square_round_mg':
      Icon = SquareRoundMg;
      break;
    case 'sha_round':
    case 'sha_circle':
    case 'sha_wpau_round':
    case 'sha_pamau_round':
      Icon = Circle;
      break;
    case 'sha_heart':
    case 'sha_wpau_heart':
    case 'sha_pamau_heart':
      Icon = Heart;
      break;
    case 'sha_oval':
    case 'sha_wpau_oval':
    case 'sha_pamau_oval':
      Icon = Oval;
      break;
    case 'sha_plaque':
    case 'sha_wpau_plaque':
      Icon = Plaque;
      break;
    case 'sha_oval_straight':
      Icon = StraightOval;
      break;
    case 'sha_hexagon':
    case 'sha_wpau_hexagon':
    case 'sha_pamau_hexagon':
      Icon = Hexagon;
      break;
    case 'sha_scallop':
    case 'sha_wpau_scallop':
      Icon = Scallop;
      break;
    case 'sha_lollipop':
    case 'sha_lidseal':
    case 'sha_wpau_lidseal':
    case 'sha_pamau_lidseal':
      Icon = LidSeal;
      break;
    case 'sha_rect_lollipop':
      Icon = LidSealRectangle;
      break;
    case 'sha_lipbalm':
    case 'sha_lip_balm':
      Icon = LipBalm;
      break;
    case 'sha_wpau_lipbalm':
      Icon = LipBalmAU;
      break;
    case 'sha_cd':
    case 'sha_wpau_cd':
    case 'sha_pamau_cd':
      Icon = CD;
      break;
    case 'sha_2rings':
      Icon = Binder2Rings;
      break;
    case 'sha_4rings':
      Icon = Binder4Rings;
      break;
    case 'sha_triangle':
      Icon = Triangle;
      break;
    case 'sha_wpau_barrel':
    case 'sha_pamau_barrel':
      Icon = Barrel;
      break;
    case 'sha_wpau_band':
    case 'sha_pamau_band':
      Icon = Band;
      break;
    //Tag Icons
    case 'sha_rectangle_tag':
      Icon = RectangleTag;
      break;
    case 'sha_rectangle_round_tag':
      Icon = RectangleRoundTag;
      break;
    case 'sha_luggage_tag':
      Icon = RectangleLuggageTag;
      break;
    case 'sha_round_tag':
      Icon = RoundTag;
      break;
    case 'sha_square_tag':
      Icon = SquareTag;
      break;
    case 'sha_square_round_tag':
      Icon = SquareRoundTag;
      break;
    case 'sha_loop_tag':
      Icon = LoopTag;
      break;
    case 'sha_plant_small_tag':
      Icon = PlantSmallTag;
      break;
    case 'sha_plant_large_tag':
      Icon = PlantLargeTag;
      break;
    case 'sha_dustcover_wi_round':
      Icon = DustCoverStandard;
      break;
    case 'sha_dustcover_wo_round':
      Icon = DustCoverWood;
      break;
    case 'sha_custom':
      Icon = CustomShape;
      break;
    case 'sha_custom_fr':
      Icon = CustomShapeFr;
      break;
    case 'sha_custom_de':
      Icon = CustomShapeDe;
      break;
    case 'sha_custom_dk':
      Icon = CustomShapeDK;
      break;
    case 'sha_custom_es':
      Icon = CustomShapeEs;
      break;
    case 'sha_custom_it':
      Icon = CustomShapeIt;
      break;
    case 'sha_custom_no':
      Icon = CustomShapeNo;
      break;
    case 'sha_custom_pl':
      Icon = CustomShapePl;
      break;
    case 'sha_custom_pt':
      Icon = CustomShapePt;
      break;
    case 'sha_custom_se':
      Icon = CustomShapeSe;
      break;
    default:
      Icon = () => <span className='[font-size:10px]'>Missing: {id}</span>;
      break;
  }

  //Some icons are lazy loaded; without a Suspense boundary their first render
  //during a synchronous update (e.g. a click) crashes the whole React root.
  //The fallback reserves the icon box so nothing shifts while the chunk loads.
  return (
    <span className="absolute inset-y-0 flex items-center">
      <Suspense fallback={<span className="w-[6rem] h-[5rem]" />}>
        <Icon className='w-[6rem] h-[5rem]' {...attributes} />
      </Suspense>
    </span>
  );
};

export default ShapeIcon;
